import styled from 'styled-components'

const Box = styled.div`
  border: 1px solid rgba(241, 209, 227, 0.16);
  position: relative;
  min-height: 40px;
  padding: 12px;
  border-radius: 15px;
`

const EBox = (props: any) => {
  return <Box {...props}>{props.children}</Box>
}

export default EBox
